/**
 * Google Analytics utility functions for user identification and event tracking
 */

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

/**
 * Set user ID for Google Analytics to identify specific users across sessions
 * @param {string} userId - Unique user identifier
 */
export const setGAUserId = (userId) => {
  if (!isGtagAvailable()) {
    console.warn('Google Analytics (gtag) not available');
    return;
  }

  if (!userId) {
    console.warn('User ID is required for GA identification');
    return;
  }

  try {
    // Set user ID for the current GA4 property
    window.gtag('config', 'G-9G8KVBFST0', {
      user_id: userId
    });

    console.log('GA User ID set:', userId);
  } catch (error) {
    console.error('Failed to set GA User ID:', error);
  }
};

/**
 * Clear user ID when user logs out
 */
export const clearGAUserId = () => {
  if (!isGtagAvailable()) {
    return;
  }

  try {
    // Clear user ID by reconfiguring without it
    window.gtag('config', 'G-9G8KVBFST0', {
      user_id: undefined
    });

    console.log('GA User ID cleared');
  } catch (error) {
    console.error('Failed to clear GA User ID:', error);
  }
};

/**
 * Track custom events with user context
 * @param {string} action - Event action name
 * @param {Object} parameters - Additional event parameters
 */
export const trackGAEvent = (action, parameters = {}) => {
  if (!isGtagAvailable()) {
    return;
  }

  try {
    window.gtag('event', action, {
      event_category: 'user_action',
      ...parameters
    });
  } catch (error) {
    console.error('Failed to track GA event:', error);
  }
};

/**
 * Track user authentication events
 * @param {string} method - Authentication method ('login', 'signup', 'logout')
 * @param {string} userId - User ID (optional for logout)
 */
export const trackAuthEvent = (method, userId = null) => {
  trackGAEvent(method, {
    event_category: 'authentication',
    user_id: userId
  });
};